import { DialogYoutubeModule } from './../dialog-youtube/dialog-youtube.module';
import { TrackingDirectiveModule } from '@toro/common/shared/directives';
import { MainTransferQuestionComponent } from './main-transfer-question.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
      MainTransferQuestionComponent,
  ],
  imports: [
    CommonModule,
    TrackingDirectiveModule,
    DialogYoutubeModule,
  ],
  exports:[
    MainTransferQuestionComponent,
  ]
})
export class MainTransferQuestionModule { }
